import { Box, CardBody, CardFooter, CardHeader, FormControl, FormErrorMessage, FormLabel, Input, Skeleton, VStack } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { SubmitBtn } from "../../../atoms/button/SubmitBtn";
import { useFetchLiff } from "../../../../hooks/externalApi/line/useFetchLiff";
import { useEditLiffForm } from "../../../../hooks/externalApi/line/useEditLiffForm";
import { useEditLiff } from "../../../../hooks/externalApi/line/useEditLiff";
import { LiffTypeSelect } from "../../../organisms/externalApi/line/LiffTypeSelect";
import { DarkShadowCard } from "../../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../../molecules/card/CardHeading";
import { SettingsIcon } from "@chakra-ui/icons";


export const EditLiff = () => {
  const { liffId } = useParams();
  const { liffRestaurants, isLoading } = useFetchLiff(liffId);
  const { handleSubmit, register, control, isSubmitting, errors } = useEditLiffForm(liffRestaurants)
  const onSubmit = useEditLiff(liffId)
  const liffIdError = errors.liff_id?.message;
  const liffUrlError = errors.liff_url?.message;
  return (
    <Box m='auto' w={{base: '100%', md: '600px'}}>
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <DarkShadowCard>
          <CardHeader>
            <CardHeading icon={<SettingsIcon />} heading='Liff設定'/>
          </CardHeader>
          <CardBody py={2}>
            <VStack spacing={5}>
              <LiffTypeSelect control={control} errors={errors} />
              <FormControl isRequired isInvalid={!!errors.liff_id} w='100%'>
                <FormLabel>LIFF ID</FormLabel>
                <Skeleton isLoaded={!isLoading} w='100%' borderRadius={5}>
                  <Input {...register('liff_id')} />
                </Skeleton>
                <FormErrorMessage>{liffIdError}</FormErrorMessage>
              </FormControl>
              <FormControl isRequired isInvalid={!!errors.liff_url} w='100%'>
                <FormLabel>LIFF URL</FormLabel>
                <Skeleton isLoaded={!isLoading} w='100%' borderRadius={5}>
                  <Input {...register('liff_url')} />
                </Skeleton>
                <FormErrorMessage>{liffUrlError}</FormErrorMessage>
              </FormControl>
            </VStack>
          </CardBody>
          <CardFooter>
            <SubmitBtn isLoading={isSubmitting}>登録</SubmitBtn>
          </CardFooter>
        </DarkShadowCard>
      </form>
    </Box>
  );
};